export const APP_API_CALL_ERROR = 'APP_API_CALL_ERROR';

export const APP_SIDE_NAV_MINIMIZE = 'APP_SIDE_NAV_MINIMIZE';
export const APP_SIDE_NAV_TOGGLE = 'APP_SIDE_NAV_TOGGLE';

export const APP_MODULE_CHANGE_ENV = 'APP_MODULE_CHANGE_ENV';

export const DATE_FORMAT = 'DD MMM YY';
export const DATETIME_FORMAT = 'DD MMM YY HH:mm';